import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companycontract.name')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companycontract.client_id')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.name')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.code')} />
  </TableCell>
</>

export default React.memo(Header)
